<template>
  <button
    class="gradient-0 text-white text-md font-bold rounded-md px-5 py-2 flex-grow-0"
  >
    <slot></slot>
  </button>
</template>
